/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIBOM } from './APIBOM';
import {
    APIBOMFromJSON,
    APIBOMFromJSONTyped,
    APIBOMToJSON,
} from './APIBOM';

/**
 * 
 * @export
 * @interface APIPaginatedBOMList
 */
export interface APIPaginatedBOMList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedBOMList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedBOMList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedBOMList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIBOM>}
     * @memberof APIPaginatedBOMList
     */
    results: Array<APIBOM>;
}

/**
 * Check if a given object implements the APIPaginatedBOMList interface.
 */
export function instanceOfAPIPaginatedBOMList(value: object): value is APIPaginatedBOMList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedBOMListFromJSON(json: any): APIPaginatedBOMList {
    return APIPaginatedBOMListFromJSONTyped(json, false);
}

export function APIPaginatedBOMListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedBOMList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIBOMFromJSON)),
    };
}

export function APIPaginatedBOMListToJSON(value?: APIPaginatedBOMList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIBOMToJSON)),
    };
}

